export enum GlobalEventNameEnum {
  Created = 'assets-tree:created',
  OpenDialog = 'assets-tree:open-dialog',
  Updated = 'assets-tree:updated'
}
